import React, { useState, useCallback } from 'react';
import { SendEmailWithGet } from '../../components';
import { PageContainer, Container } from './TestEmail.styled';

const TestEmail = () => {
  const [fromEmail, setFromEmail] = useState('example@dealerlakes.com');
  const [sendTo, setSendTo] = useState('');
  const [subject, setSubject] = useState('');
  const [body, setBody] = useState('');

  const fromEmailOptions = [
    { value: 'example@dealerlakes.com', label: 'example@dealerlakes.com' },
    { value: 'sales@dealerlakes.com', label: 'sales@dealerlakes.com' },
    { value: 'support@dealerlakes.com', label: 'support@dealerlakes.com' },
  ];

  const handleFromEmailChange = useCallback((value) => {
    setFromEmail(value);
    
  }, []);

  const handleSendToChange = useCallback((value) => {
    setSendTo(value);
    
  }, []);

  const handleSubjectChange = useCallback((value) => {
    setSubject(value);
    
  }, []);

  const handleBodyChange = useCallback((value) => {
    setBody(value);
  }, []);

  const handleCancel = useCallback(() => {
    setSendTo('');
    setSubject('');
    setBody('');
  }, []);

  const handleSend = useCallback(() => {
    alert('Email would be sent! Check console for details.');
  }, [fromEmail, sendTo, subject, body]);

  const handleAIGenerate = useCallback(() => {
    alert('AI Generate feature clicked');
  }, []);

  const handleAttachFile = useCallback(() => {
    alert('Attach file feature clicked');
  }, []);

  const handleInsertLink = useCallback(() => {
    alert('Insert link feature clicked');
  }, []);

  const handleDelete = useCallback(() => {
    if (window.confirm('Are you sure you want to delete this draft?')) {
      setSendTo('');
      setSubject('');
      setBody('');
    }
  }, []);

  const handleCcClick = useCallback(() => {
    alert('Cc field would be shown');
  }, []);

  return (
    <PageContainer>
      <Container>
        <SendEmailWithGet
          fromEmail={fromEmail}
          fromEmailOptions={fromEmailOptions}
          onFromEmailChange={handleFromEmailChange}
          sendTo={sendTo}
          onSendToChange={handleSendToChange}
          subject={subject}
          onSubjectChange={handleSubjectChange}
          body={body}
          onBodyChange={handleBodyChange}
          onCancel={handleCancel}
          onSend={handleSend}
          onAIGenerate={handleAIGenerate}
          onAttachFile={handleAttachFile}
          onInsertLink={handleInsertLink}
          onDelete={handleDelete}
          onCcClick={handleCcClick}
        />
      </Container>
    </PageContainer>
  );
};

export default TestEmail;

